import keyMirror from 'keymirror';

export const payInvoiceModalActionTypes = keyMirror({
	TOGGLE_PAY_INVOICE_MODAL: null,

	SEND_INVOICE_TO_PARENT_REQUEST: null,
	SEND_INVOICE_TO_PARENT_SUCCESS: null,
	SEND_INVOICE_TO_PARENT_ERROR: null,
});
